import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsDefectSeverity, PmsDefectSeverity } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsDefectSeverity>
    useData={usePmsDefectSeverity}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
